import { Button } from '@eventbrite/marmalade';
import { FormattedMessage } from 'react-intl';

import { useBasicInfo } from '@/components/_shared/contexts/BasicInfoContext';

import { GET_TICKETS_MESSAGE } from '../CheckoutButton/CheckoutButton';
import { useExternalTicketsHeadline } from './hooks/useExternalTicketsHeadline';
import styles from './ExternalTicketsPanel.module.scss';

type ExternalTicketsPanelCtaProps = {
  wrapperClassName?: string;
};

export const ExternalTicketsPanelCta: React.FC<ExternalTicketsPanelCtaProps> = ({ wrapperClassName }) => {
  const { externalTicketing } = useBasicInfo();
  const { isExternalTicketingInformationAvailable } = useExternalTicketsHeadline();
  const externalTicketsUrl = externalTicketing?.externalTicketsUrl ?? '';

  if (!isExternalTicketingInformationAvailable) {
    return null;
  }

  return (
    <div data-testid="cb-cta-area" className={wrapperClassName ?? styles.ctaButtonWrapper}>
      <Button
        variant="primary"
        onClick={() => window.open(externalTicketsUrl, '_blank', 'noreferrer noopener')}
        data-testid="external-tickets-link"
      >
        <FormattedMessage {...GET_TICKETS_MESSAGE} />
      </Button>
    </div>
  );
};
